import styled from 'styled-components';
import { Button, Input, Form } from 'antd';

export const Container = styled.div`
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  width: 100%;
`;

export const FormTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const FormExplanation = styled.div`
  background-color: #f2f2f2;
  width: 100%;
  padding: 10px 0;
  text-align: center;
  font-size: 13px;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;

  td {
    border: 1px solid #d9d9d9;
    padding: 8px;
    font-size: 13px;
    vertical-align: middle;
  }

  td:first-child {
    background-color: #f5f5f5;
    font-size: 13px;
    font-weight: 500;
    width: 20%;
    height: 45px;
    vertical-align: middle;
    border-left: none;
  }

  td:last-child {
    border-right: none;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: flex-start;

  width: 100%;
`;

export const DuplicateCheckButton = styled(Button)`
  margin-left: 8px;
  background-color: #225f9b;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  min-width: 60px;
  min-height: 30px;
`;

export const StyledInput = styled(Input)`
  border-radius: 4px;
  min-width: 270px;
  max-width: 270px;
`;

export const StyledPasswordInput = styled(Input.Password)`
  border-radius: 4px;
  width: 100%;
`;

export const StyledInputGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    margin: 0 4px;
  }

  .ant-form-item {
    flex: 1;
  }

  .ant-input {
    width: 100%;
    max-width: 100px;
    flex: 1;
  }
`;

export const StyledPhoneInput = styled(Input)`
  border-radius: 4px;
  max-width: 100px;
`;

export const ErrorText = styled.p`
  color: red;
  margin-top: 10px;
`;

export const StyledStarSign = styled.span`
  color: red;
  margin: 0 2px;
  vertical-align: middle;
  font-size: 12px;
`;

export const StyledFormItem = styled(Form.Item)`
  margin: 0;

  .ant-form-item {
    margin: none;
  }

  .ant-form-item-control-input-content {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0;
  }

  &.ant-form-item {
    padding: 0;
  }

  .ant-form-item-control {
    border: none;
  }
`;
